import React, { useState } from 'react';
import { Info } from 'lucide-react';

export default function RadioQualifiedListenInfo({
  buttonClassName = 'jg-radio-dock-info-btn',
  popoverClassName = 'jg-radio-dock-play-info-popover',
  tooltipId = 'jg-radio-dock-play-count-info',
}) {
  const [open, setOpen] = useState(false);

  return (
    <span
      className="jg-radio-dock-info-wrap"
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className={buttonClassName}
        aria-label="How plays are counted"
        aria-expanded={open}
        aria-describedby={open ? tooltipId : undefined}
        onClick={() => setOpen((current) => !current)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onMouseEnter={() => setOpen(true)}
      >
        <Info aria-hidden="true" size={14} />
      </button>
      {open ? (
        <span id={tooltipId} className={popoverClassName} role="tooltip">
          <strong>How plays are counted</strong>
          <span>
            A play counts after someone listens long enough: at least 30 seconds
            or 25% of the record.
          </span>
          <span>
            Logged-in JG Players count once per record per day.
          </span>
          <span>
            Public HitLab preview listens can also count once per visitor
            session per record per day.
          </span>
          <span>Bumpers do not count.</span>
        </span>
      ) : null}
    </span>
  );
}
